import Vue from 'vue'
import Router from 'vue-router'
import Login from '../components/Login.vue'
import Register from '../components/Register.vue'
import request from '../utils/request' // 导入配置好的axios实例
import Fingerprint2 from 'fingerprintjs2'
// 导入main layout
import MainLayout from '../layout/MainLayout.vue'

// 导入页面组件
import Home from '../pages/Home.vue'
import DynamicHouse from '../pages/DynamicHouse.vue'
// import StaticHouse from '../pages/StaticHouse.vue'
import FAQPage from '../pages/FAQPage.vue'
import ServicePolicy from '../pages/ServicePolicy.vue'
import PrivacyPolicy from '../pages/PrivacyPolicy.vue'
// 导入dashboard页面组件
import DashboardBase from '../pages/dashboard/Base.vue'
import SubAccount from '../pages/dashboard/SubAccount.vue'
import Traffic from '../pages/dashboard/Traffic.vue'
import LoginRecord from '../pages/dashboard/LoginRecord.vue'
import FlowRecord from '../pages/dashboard/FlowRecord.vue'
// 导入购买页面组件
import Purchase from '../pages/purchase/Index.vue'
// 导入用户设置页面组件
import UserSettings from '../pages/user/Settings.vue'
// 导入静态住宅页面组件
// import StaticNux from '../pages/staticnux/Index.vue'
// import StaticNativePurchase from '../pages/staticnux/Purchase.vue'
// import StaticBroadcastPurchase from '../pages/staticnux/BroadcastPurchase.vue'
// 导入工具页面组件
import QRCodeGenerator from '../pages/utiltools/QRCodeGenerator.vue'
import ProxyTester from '../pages/utiltools/ProxyTester.vue'
// 导入API文档页面组件
// import DynamicApi from '../pages/api-docs/DynamicApi.vue'
// import StaticApi from '../pages/api-docs/StaticApi.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    // 登录和注册页面不使用layout
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    
    // 原本的页面不使用layout，直接作为顶层路由
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/dynamic',
      name: 'DynamicHouse',
      component: DynamicHouse
    },
    // {
    //   path: '/static',
    //   name: 'StaticHouse',
    //   component: StaticHouse
    // },
    {
      path: '/faq',
      name: 'FAQPage',
      component: FAQPage
    },
    {
      path: '/service-policy',
      name: 'ServicePolicy',
      component: ServicePolicy
    },
    {
      path: '/privacy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy
    },
    
    // dashboard页面路由 - 使用MainLayout布局
    {
      path: '/dashboard',
      name: 'DashboardLayout',
      component: MainLayout,
      children: [
        {
          path: 'base',
          name: 'DashboardBase',
          component: DashboardBase
        },
        {
          path: 'sub-account',
          name: 'SubAccount',
          component: SubAccount
        },
        {
          path: 'traffic',
          name: 'Traffic',
          component: Traffic
        },
        {
          path: 'login-record',
          name: 'LoginRecord',
          component: LoginRecord
        },
        {
          path: 'flow-record',
          name: 'FlowRecord',
          component: FlowRecord
        }
      ]
    },
    
    // 购买页面路由 - 使用MainLayout布局
    {
      path: '/purchase',
      name: 'PurchaseLayout',
      component: MainLayout,
      children: [
        {
          path: 'buy',
          name: 'Purchase',
          component: Purchase
        }
      ]
    },
    
    // 静态住宅页面路由 - 使用MainLayout布局
    // {
    //   path: '/staticnux',
    //   name: 'StaticNuxLayout',
    //   component: MainLayout,
    //   children: [
    //     {
    //       path: 'index',
    //       name: 'StaticNux',
    //       component: StaticNux
    //     },
    //     {
    //       path: 'purchase',
    //       name: 'StaticNativePurchase',
    //       component: StaticNativePurchase
    //     },
    //     {
    //       path: 'broadcast-purchase',
    //       name: 'StaticBroadcastPurchase',
    //       component: StaticBroadcastPurchase
    //     }
    //   ]
    // },
    
    // 工具页面路由 - 使用MainLayout布局
    {
      path: '/utiltools',
      name: 'UtilToolsLayout',
      component: MainLayout,
      children: [
        {
          path: 'qrcode',
          name: 'QRCodeGenerator',
          component: QRCodeGenerator
        },
        {
          path: 'proxy-tester',
          name: 'ProxyTester',
          component: ProxyTester
        }
      ]
    },
    
    // API文档页面路由 - 使用MainLayout布局
    // {
    //   path: '/api-docs',
    //   name: 'ApiDocsLayout',
    //   component: MainLayout,
    //   children: [
    //     {
    //       path: 'dynamic',
    //       name: 'DynamicApi',
    //       component: DynamicApi
    //     },
    //     {
    //       path: 'static',
    //       name: 'StaticApi',
    //       component: StaticApi
    //     }
    //   ]
    // },
    
    // 用户设置页面路由 - 使用MainLayout布局
    {
      path: '/user',
      name: 'UserLayout',
      component: MainLayout,
      children: [
        {
          path: 'settings',
          name: 'UserSettings',
          component: UserSettings
        }
      ]
    }
  ]
})

// 路由拦截器 - 检查登录状态
router.beforeEach((to, from, next) => {
  // 判断当前 URL 中是否包含 invitation 参数
  if (to.query.invitation) {
    const invitationCode = to.query.invitation;
    
    // 【防刷机制】：使用 sessionStorage 记录当前会话是否已经上报过该邀请码
    // 作用：防止用户在这个页面频繁按 F5 刷新，导致前端疯狂调用接口
    const logFlag = `VISIT_LOGGED_${invitationCode}`;
    
    if (!sessionStorage.getItem(logFlag)) {
      // 获取浏览器指纹
      Fingerprint2.get((components) => {
        const fingerprint = Fingerprint2.x64hash128(components.map(c => c.value).join(''))
        // 发起异步请求，不需要 await，绝不能阻塞 next() 的执行
        request.post('/auth/visit-log', { invitationCode, fingerprint })
          .then((res) => {
            // 请求成功后，在当前浏览器会话中打上标记
            sessionStorage.setItem(logFlag, 'true');

            // 修复: 只有当 res.data.data 确实有值时，才写入 localStorage
            if (res && res.data && res.data.data !== undefined && res.data.data !== null) {
              localStorage.setItem('PROMO_VISIT_LOG_ID', res.data.data);
            }
          })
          .catch(err => {
            console.error('上报推广访问日志失败:', err);
          });
      })
    }
  }

  // 获取token
  const token = localStorage.getItem('Token') || localStorage.getItem('Authorization')
  
  // 定义需要登录才能访问的路由
  // 将/utiltools路径添加到需要登录验证的路由中，确保工具页面权限一致性
  const requiresAuth = to.path.startsWith('/dashboard') || to.path.startsWith('/purchase') || to.path.startsWith('/user') || to.path.startsWith('/staticnux') || to.path.startsWith('/utiltools')
  
  // 如果需要登录但没有token，重定向到登录页面
  if (requiresAuth && !token) {
    next('/login')
  } else {
    // 否则允许访问
    next()
  }
})

export default router